import React from 'react';
import { Dialog, Fade } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styles from './UnsavedChangesModal.module.scss';

interface UnsavedChangesModalProps {
    open: boolean;
    onClose: () => void;
    onExitWithoutSaving?: () => void;
    onSaveAndExit: () => void;
    isPreviewMode?: boolean;
    description?: string;
}

export const UnsavedChangesModal: React.FC<UnsavedChangesModalProps> = ({
    open,
    onClose,
    onExitWithoutSaving,
    onSaveAndExit,
    isPreviewMode,
    description
}) => {
    const { t } = useTranslation();

    return (
        <Dialog 
            open={open} 
            onClose={onClose}
            maxWidth="sm" 
            TransitionComponent={Fade}
            transitionDuration={200}
            PaperProps={{
                className: styles['modal']
            }}
            slotProps={{
                backdrop: {
                    className: styles['modal-backdrop']
                }
            }}
        >
            <h2 id="exit-modal-title" className={styles['modal-title']}>
                {t('appAdmin.UnsavedChangesModal.title', 'Cambios sin guardar')}
            </h2>
            <p id="exit-modal-copy" className={styles['modal-copy']}>
                {description || t('appAdmin.UnsavedChangesModal.description', 'Si salís ahora, los cambios realizados en tu perfil se van a perder.')}
            </p>
            <div className={styles['modal-actions']}>
                <button 
                    className={`${styles['btn']} ${styles['btn-secondary']}`} 
                    id="modal-continue" 
                    type="button"
                    onClick={onClose}
                >
                    {t('appAdmin.UnsavedChangesModal.continueEditing', 'Seguir editando')}
                </button>
                {!isPreviewMode && onExitWithoutSaving && (
                    <button 
                        className={`${styles['btn']} ${styles['btn-secondary']}`} 
                        id="modal-discard" 
                        type="button"
                        onClick={onExitWithoutSaving}
                    >
                        {t('appAdmin.UnsavedChangesModal.exitWithoutSaving', 'Salir sin guardar')}
                    </button>
                )}
                <button 
                    className={styles['save-cta']} 
                    id="modal-save-exit" 
                    type="button"
                    onClick={onSaveAndExit}
                >
                    {isPreviewMode 
                        ? t('appAdmin.UnsavedChangesModal.saveAndPreview', 'Guardar y previsualizar')
                        : t('appAdmin.UnsavedChangesModal.saveAndExit', 'Guardar y salir')}
                </button>
            </div>
        </Dialog>
    );
};